<template>
  <v-card class="pb-1">
    <IngestionResultsLogDialog ref="ingestionResultsDialog" />
    <Subheader class="pb-2">
      <template v-slot:title>
        <v-toolbar-title>
          <v-icon medium>event_note</v-icon>
          <span class="headline"> {{ title }} </span>
        </v-toolbar-title>
      </template>
      <template v-slot:actions v-if="supportsRefresh">
        <v-btn icon :loading="loading" @click="refresh">
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
    </Subheader>
    <div class="text-xs-center pt-5 pb-3" v-if="loading">
      <v-progress-circular size="50" color="info" class="mx-auto" indeterminate />
      <div class="my-3">Loading import events</div>
    </div>
    <template v-else-if="error">
      <v-alert type="error" :value="true">Failed to load import events.</v-alert>
    </template>
    <template v-else>
      <ImportCard
        v-for="(indexId, j) in displayItems"
        @show:logs="showIngestionLogs(indexId)"
        :key="`import-${j}`"
        :indexId="indexId"
      />
    </template>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ImportCard from '@/components/Imports/ImportCard'
import IngestionResultsLogDialog from '@/components/Imports/IngestionResultsLogDialog'

const ingestions = createNamespacedHelpers('ingestions')

export default {
  name: 'LatestIngestionEventsWidget',
  components: {
    ImportCard,
    IngestionResultsLogDialog,
  },
  props: {
    widgetId: { type: String, required: true },
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  computed: {
    ...ingestions.mapState(['importIds', 'importsIndex']),
    title() {
      return this.config.title || 'Latest Import Events'
    },
    maxItems() {
      return this.config.maxItems || 5
    },
    displayItems() {
      if (!this.importIds) return []
      return this.importIds.slice(0, this.maxItems)
    },
    supportsRefresh() {
      return this.config.supportsRefresh !== false
    },
  },
  methods: {
    ...ingestions.mapActions(['fetchIngestionResults']),
    async initialize() {
      this.loading = true
      this.error = null
      try {
        if (!this.importIds || this.importIds.length === 0) {
          await this.fetchIngestionResults({
            startDate: null,
            endDate: null,
            searchText: null,
            executionId: null,
          })
        }
        this.$store.dispatch('dashboard/setWidgetData', { widgetId: this.widgetId, data: true })
        this.loading = false
      } catch (err) {
        this.error = err
        this.loading = false
        this.$store.dispatch('dashboard/setWidgetError', { widgetId: this.widgetId, error: err })
      }
    },
    async refresh() {
      this.loading = true
      this.error = null
      try {
        await this.fetchIngestionResults({
          startDate: null,
          endDate: null,
          searchText: null,
          executionId: null,
        })
        this.loading = false
      } catch (err) {
        this.error = err
        this.loading = false
      }
    },
    showIngestionLogs(importId) {
      const item = this.importsIndex[importId]
      if (item) {
        this.$refs.ingestionResultsDialog.show(item.executionId, item.isRollback)
      }
    },
  },
}
</script>
